import { render, staticRenderFns } from "./UiHeaderUserCart.vue?vue&type=template&id=0be95e1d&"
import script from "./UiHeaderUserCart.vue?vue&type=script&lang=js&"
export * from "./UiHeaderUserCart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports